// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__QaNNv","resendInfoText":"OnGoingPaymentBox_resendInfoText__1DQtI"};